/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  /*
   *  add_marker
   *
   *  This function will add a marker to the selected Google Map
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	$marker (jQuery element)
   *  @param	map (Google Map object)
   *  @return	n/a
   */

  function add_marker($marker, map) {
    // var
    var latlng = new google.maps.LatLng(
      $marker.attr("data-lat"),
      $marker.attr("data-lng")
    );

    // create marker
    var marker = new google.maps.Marker({
      position: latlng,
      map: map
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html()
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, "click", function() {
        infowindow.open(map, marker);
      });
    }
  }

  /*
   *  center_map
   *
   *  This function will center the map, showing all markers attached to this map
   *
   *  @type  function
   *  @date  8/11/2013
   *  @since 4.3.0
   *
   *  @param map (Google Map object)
   *  @return  n/a
   */

  function center_map(map) {
    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function(i, marker) {
      var latlng = new google.maps.LatLng(
        marker.position.lat(),
        marker.position.lng()
      );

      bounds.extend(latlng);
    });

    // only 1 marker?
    if (map.markers.length === 1) {
      // set center of map
      map.setCenter(bounds.getCenter());
      map.setZoom(16); // Set Zoom of the Map! IMPORTANT!
    } else {
      // fit to bounds
      map.fitBounds(bounds);
    }
  }

  /*
   * add_custom Style
   *
   * @date 17/03/2015
   * since 1.0
   *
   * © carol burri
   */

  var featureOpts = [
    {
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#a9332a"
        }
      ]
    },
    {
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#a9332a"
        }
      ]
    },
    {
      elementType: "labels.icon",
      stylers: [
        {
          color: "#a9332a"
        }
      ]
    },
    {
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#a9332a"
        }
      ]
    },
    {
      elementType: "labels.text.stroke",
      stylers: [
        {
          color: "#f9ce7d"
        }
      ]
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#f9ce7d"
        }
      ]
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#f9ce7d"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#f9ce7d"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#a9332a"
        }
      ]
    },
    {
      featureType: "road.local",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#f9ce7d"
        }
      ]
    },
    {
      featureType: "road.local",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#a9332a"
        }
      ]
    },
    {
      featureType: "transit.line",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#a9332a"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#a9332a"
        }
      ]
    }
  ];

  /*
   *  render_map
   *
   *  This function will render a Google Map onto the selected jQuery element
   *
   *  @type  function
   *  @date  8/11/2013
   *  @since 4.3.0
   *
   *  @param $el (jQuery element)
   *  @return  n/a
   */

  function render_map($el) {
    // var
    var $markers = $el.find(".marker");

    // vars
    var args = {
      zoom: 0,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMA,
      styles: featureOpts,
      disableDefaultUI: true
    };

    // create map
    var map = new google.maps.Map($el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function() {
      add_marker($(this), map);
    });

    // center map
    center_map(map);
  }

  function burgerMenu() {
    $(".main-navigaton").hide();
    $(".nav-burger").click(function() {
      $(".wrap").toggle(0); // Hide Content
      // $("header").toggleClass("h-100"); // Make Yellow Background full Height
      $(this).toggleClass("open");
      $(".main-navigaton").toggle(100);
    });
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        burgerMenu();
        $(".fitText").fitText(1.2);
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    home: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        const hash = window.location.hash;

        const flickerHolder = $(".flicker");
        if(!hash) {
          const images = $(".flicker div");

          let cycle = 0;

          function setImage(images) {
            if (cycle > 10) {
              clearInterval(flicker);
              flickerHolder.remove();
            }

            // flickerHolder.children().css("display", "none");
            $(".flicker div")
              .eq(Math.floor(Math.random() * images.length))
              .css("z-index", cycle);

            cycle++;
          }

          const flicker = setInterval(setImage, 200, images);
        } else {
          flickerHolder.remove();
        }
      }
    },
    kontakt: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        $(".acf-map").each(function() {
          render_map($(this));
        });
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    post_type_archive_mitarbeiter: {
      init: function() {
        // JavaScript to be fired on the about us page
        $(".row.about-us").mousewheel(function(event, delta) {
          this.scrollLeft -= delta * event.deltaFactor;
          event.preventDefault();
        });
      },
      finalize: function() {}
    },
    post_type_archive_referenzen: {
      init: function() {
        $(".item").hover(
          function() {
            $(this)
              .find(".image")
              .hide();
          },
          function() {
            $(this)
              .find(".image")
              .show();
          }
        );
        // JavaScript to be fired on the about us page
      },
      finalize: function() {}
    },
    post_type_archive_dienstleistungen: {
      init: function() {
        // JavaScript to be fired on the about us page
        $(".services").mousewheel(function(event, delta) {
          this.scrollLeft -= delta * event.deltaFactor;
          event.preventDefault();
        });
      },
      finalize: function() {}
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
